const SalesDetail = {
  'pages_sales_info.title': '청구 정보 상세',
  'pages_sales_info.menu_parent': '청구 정보',
  'pages_sales_info.menu_children': '청구 정보 상세',
  'pages_sales_info_bill_info.title': '청구 정보 상세',
  'pages_sales_info_bill_info.total_amount': '총 청구 금액(VAT 포함)',
  'pages_sales_info_bill_info.total_unpaid_amount': '총 납부전 금액',
  'pages_sales_info_bill_info.manager_title': '담당자 정보',
  'pages_sales_info_bill_info.manager': '담당자',
  'pages_sales_info_bill_info.manager_tel': '전화번호',
  'pages_sales_info_bill_info.manager_email': '이메일',

  'pages_sales_info_invoice.title': '인보이스별 비용',
  'pages_sales_info_invoice.no': 'no.',
  'pages_sales_info_invoice.all': '전체',
  'pages_sales_info_invoice.month': '청구월',
  'pages_sales_info_invoice.invoice_no': '인보이스 No.',
  'pages_sales_info_invoice.invoice_date': '인보이스 발행 일자',
  'pages_sales_info_invoice.total_amount': '총 청구 금액',
  'pages_sales_info_invoice.unpaid_amount': '납부전 금액',
  'pages_sales_info_invoice.paid_status': '납부 상태',
  'pages_sales_info_invoice.etc_action': '추가 기능',
  'pages_sales_info_invoice.resend': '재발송',
  'pages_sales_info_invoice.number': '청구서 번호',
  'pages_sales_info_invoice.resend_req': '재발송 요청을 하시겠습니까?',

  'pages_sales_info_invoice_chart.title': '월별 비용 트렌드',
  'pages_sales_info_invoice_chart.payment': '납부 금액',
  'pages_sales_info_invoice_chart.un_payment': '미납부 금액',
  'pages_sales_info_invoice_chart.cancel': '취소',
  'pages_sales_info_invoice.paid_status.before': '납부전',
  'pages_sales_info_invoice.paid_status.complete': '완납',
  'pages_sales_info_invoice.paid_status.notcomplete': '부분납',




}

export default SalesDetail



// WEBPACK FOOTER //
// ./src/lang/sales/SalesDetail.kr.js